import React, { useState, useContext, useEffect } from 'react';
import moment from 'moment';
import { Grid, TextField } from '@material-ui/core';
import StepperContext from './StepperFlow/StepperContext';
import StepperTitle from './elements/StepperTitle';
import StepperSubtitle from './elements/StepperSubtitle';

const PaymentsSchedulePaymentsStep2 = () => {
  const {
    state: { payrollPaymentDate },
    updateState,
  } = useContext(StepperContext);
  const [payrollName, setPayrollName] = useState(
    moment(new Date(payrollPaymentDate)).format('[Facturas del] DD [de] MMMM')
  );

  const onChangeInput = evt => {
    const { value } = evt.target;
    setPayrollName(value);
    updateState({
      payrollName: value,
    });
  };

  useEffect(() => {
    updateState({
      payrollName,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container item>
      <StepperTitle>Ingresa un nombre para el listado de facturas</StepperTitle>
      <StepperSubtitle>
        Por favor, ingresa la fecha en la que deseas realizar el pago.
      </StepperSubtitle>

      <TextField
        fullWidth
        label="Nombre del listado de facturas"
        id="outlined-basic"
        variant="outlined"
        color="secondary"
        onChange={onChangeInput}
        value={payrollName}
      />
    </Grid>
  );
};

export default PaymentsSchedulePaymentsStep2;
